// Types
import type { TGetDropdownPosition } from './Dropdown.type';

// Constants
import { DROPDOWN_GAP, DROPDOWN_POSITION } from './Dropdown.constant';

export const getDropdownPosition: TGetDropdownPosition = (params) => {
	const { position, dropdownHeight, dropdownWidth, triggerHeight, triggerWidth, triggerTop, triggerLeft } = params;

	switch (position) {
		case DROPDOWN_POSITION['top-left']: {
			return {
				top: triggerTop - dropdownHeight - DROPDOWN_GAP,
				left: triggerLeft,
			}
		}
		case DROPDOWN_POSITION['top-right']: {
			return {
				top: triggerTop - dropdownHeight - DROPDOWN_GAP,
				left: triggerLeft + triggerWidth - dropdownWidth,
			}
		}
		case DROPDOWN_POSITION['right-top']: {
			return {
				top: triggerTop,
				left: triggerLeft + triggerWidth + DROPDOWN_GAP,
			}
		}
		case DROPDOWN_POSITION['right-center']: {
			return {
				top: triggerTop + triggerHeight / 2 - dropdownHeight / 2,
				left: triggerLeft + triggerWidth + DROPDOWN_GAP,
			}
		}
		case DROPDOWN_POSITION['right-bottom']: {
			return {
				top: triggerTop + triggerHeight - dropdownHeight,
				left: triggerLeft + triggerWidth + DROPDOWN_GAP,
			}
		}
		case DROPDOWN_POSITION['bottom-left']: {
			return {
				top: triggerTop + triggerHeight + DROPDOWN_GAP,
				left: triggerLeft,
			}
		}
		case DROPDOWN_POSITION['bottom-center']: {
			return {
				top: triggerTop + triggerHeight + DROPDOWN_GAP,
				left: triggerLeft + triggerWidth / 2 - dropdownWidth / 2,
			}
		}
		case DROPDOWN_POSITION['bottom-right']: {
			return {
				top: triggerTop + triggerHeight + DROPDOWN_GAP,
				left: triggerLeft + triggerWidth - dropdownWidth,
			}
		}
		case DROPDOWN_POSITION['left-top']: {
			return {
				top: triggerTop,
				left: triggerLeft - dropdownWidth - DROPDOWN_GAP,
			}
		}
		case DROPDOWN_POSITION['left-center']: {
			return {
				top: triggerTop + triggerHeight / 2 - dropdownHeight / 2,
				left: triggerLeft - dropdownWidth - DROPDOWN_GAP,
			}
		}
		case DROPDOWN_POSITION['left-bottom']: {
			return {
				top: triggerTop + triggerHeight - dropdownHeight,
				left: triggerLeft - dropdownWidth - DROPDOWN_GAP,
			}
		}
		default: {
			return {
				top: triggerTop - dropdownHeight - DROPDOWN_GAP,
				left: triggerLeft + triggerWidth / 2 - dropdownWidth / 2,
			}
		}
	}
}
